// prettier-ignore
export const firebaseConfig = {
apiKey: "AIzaSyA3gq7ATAScDY7ab7qyAywy9cgFpzq4w1U", authDomain: "pruforce-fc8b8.firebaseapp.com",projectId: "pruforce-fc8b8",storageBucket: "pruforce-fc8b8.appspot.com",messagingSenderId: "618021898898",appId: "1:618021898898:web:2b255d736b84272618f44b", measurementId: "G-2PQRZCHKJL"
};
